import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import UploadDropzone from "../../../../../ui/FileIUpload/UploadDropzone";
import { addImages } from "../../../../store/actions";
import { deleteImage } from "../../../../store/delete";
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Link from '@material-ui/core/Link';
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";

const useStyles = makeStyles(() => ({
  zone: {
    marginTop: 35
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  titleBar: {
    height: 50,
    opacity: 0,
    '-webkit-transition': 'opacity 300ms ease-in',
       '-moz-transition': 'opacity 300ms ease-in',
        '-ms-transition': 'opacity 300ms ease-in',
         '-o-transition': 'opacity 300ms ease-in',
            'transition': 'opacity 300ms ease-in'
  },
  titleBarIcon: {
    color: "#ffffff",
  },
  photoTitle: {
    color: "#ffffff",
  },
  gridTile: {
    cursor:'pointer',
    '&:hover': {
      '& .MuiGridListTileBar-root': {
        opacity: 1
      }
    }
  }
}));

const Photos = ({addImages, deleteImage, facilityId, editmode, card }) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedFileId, setSelectedFileId] = React.useState(null);

  return (
    <div className={classes.zone}>
      <DeleteConfirmationModal
        modalText="Удалить фотографию?"
        open={modalOpen}
        onConfirm={() => deleteImage(selectedFileId)}
        handleClose={() => {setModalOpen(false); setSelectedFileId(null);}}
      />
      {card && ((card.photos && card.photos.length > 0) || editmode) &&
      <Typography className={classes.heading}>Фотографии</Typography>}

      <div>
        <GridList className={classes.gridList} cols={2.5}>
          {card && card.photos && card.photos.map(({ fileId }) => (
            <GridListTile key={fileId} classes={{tile: classes.gridTile}}>
              <img src={`${baseURL}/${fileId}`} alt={fileId} />
              {editmode && (<GridListTileBar
                title={
                  <Typography>
                    <Link
                      component="button"
                      variant="body2"
                      color="inherit"
                      onClick={() => {
                        console.info("Сделать основным");
                      }}
                    >
                      Сделать основным
                    </Link>
                </Typography>
                }
                classes={{
                  root: classes.titleBar,
                  title: classes.photoTitle,
                }}
                actionIcon={
                  <IconButton onClick={() => { setModalOpen(true); setSelectedFileId(fileId); }}
                              title="Удалить фото"
                              className={classes.titleBarIcon}>
                    <DeleteOutlineIcon/>
                  </IconButton>
                }
              />)}
            </GridListTile>
          ))}
        </GridList>
      </div>

      {editmode && (
      <div className={classes.zone}>
        <UploadDropzone onDrop={addImages} accept={".jpg,.jpeg,.png"} maxSize={4000000}/>
      </div>)}
    </div>
  );
};

const mapStateToProps = state => ({
  card: state.facilities.facilityCard
});

const mapDispatchToProps = dispatch => ({
  addImages: images => dispatch(addImages(images)),
  deleteImage: fileId => dispatch(deleteImage(fileId))
});
export default connect(mapStateToProps, mapDispatchToProps)(Photos);
